import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { GrClose } from "react-icons/gr";
import { htmlProps } from "../../utility/sanitizeHtml"
import "../AppModal/ModalKit.css";

interface PropData {
    show: any;
    isClose: any;
    message: any;
    isShowButton?: any;
    isHtml?: boolean;
}

const WarningModal = (props: PropData) => {
    const [open, setOpen] = useState(true)

    const handleClose = () => {
        props.isClose();
    };

    return (
        <div>
            {props.show &&
                <Transition.Root show={open} as={Fragment}>
                    <Dialog as="div" className="relative z-[1050]" onClose={() => setOpen(false)}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-[rgba(28,31,62,0.55)] transition-opacity" />
                        </Transition.Child>

                        <div className="fixed inset-0 z-[1050] overflow-y-auto">
                            <div className="flex min-h-full items-center justify-center p-4">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                >
                                    <Dialog.Panel className="fpm-panel fpm-sm">
                                        <button type="button" className="fpm-x" title="Close" onClick={handleClose}>
                                            <GrClose size={15} />
                                        </button>
                                        <div className="fpm-modal">
                                            <div className="fpm-head">
                                                <div className="fpm-badge fpm-badge-red">
                                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><path d="M12 9v4" /><path d="M12 17h.01" /></svg>
                                                </div>
                                                <Dialog.Title as="h2">Warning</Dialog.Title>
                                            </div>
                                            {props.isHtml == true
                                                ? <div className="fpm-msg" dangerouslySetInnerHTML={htmlProps(props.message)} />
                                                : <p className="fpm-msg">{props.message}</p>
                                            }
                                            {
                                                !props.isShowButton &&
                                                <div className="fpm-foot">
                                                    <button
                                                        type="button"
                                                        className="fpm-btn-brand"
                                                        onClick={handleClose}
                                                    >
                                                        Go back
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition.Root>
            }
        </div>
    );
};

export default WarningModal;
